export const AppRouterKeys = {
	HOME:         '/',
	CLUBS:        '/clubs',
	CLUBS_CREATE: '/clubs/create',
	CLUB_DETAIL:  '/clubs/:clubId',
	GAMES:        '/games',
	GAME:         '/games/:gameId',
	ROOM:         '/rooms/:roomId',
	ROOM_CREATE:  '/clubs/:clubId/rooms/create',
	MY_PROFILE:   '/profile',
	PROFILE:      '/profile/:userId',
	RULES:        '/rules',
	RULES_DETAIL: '/rules/:gameModeId',

	ADMIN:     '/admin',

	SIGN_IN:   '/sign-in',
	SIGN_UP:   '/sign-up',

	FORBIDDEN: '/',
	ALL_MATCH: '/*',
} as const
